import { useMemo } from "react"

import useIsDesktop from "@hooks/useIsDesktop"
import useNavigationLinks, { NavigationLink } from "@hooks/useNavigationLinks"
import useUser from "@hooks/useUser"

import filterUserLinks from "@utils/filterUserLinks"
import generateRandomKey from "@utils/generateRandomKey"

import { NavigationItem, WorkspaceSelector } from "@molecules"

import { BottomBar, StackedNavigationItems, UserProfileButton } from "@organisms"

import { AppFrame } from "@templates"

import styles from "./Menu.module.scss"

function MenuContent() {
    const { user } = useUser()
    const isDesktop = useIsDesktop()

    const { home, calendar, estimates, jobs, invoices, purchase_orders, bills, vendors, clients, pricebook, reports } =
        useNavigationLinks()

    const links: NavigationLink[] = [
        home,
        calendar,
        estimates,
        jobs,
        invoices,
        purchase_orders,
        bills,
        vendors,
        clients,
        pricebook,
        reports,
    ]

    const filteredLinks = useMemo(() => filterUserLinks(links, user), [links, user])

    return (
        <>
            {!isDesktop && (
                <>
                    <div className={styles.header}>
                        <div className={styles.headerInner}>
                            <WorkspaceSelector />
                            <UserProfileButton />
                        </div>
                    </div>
                    <div className={styles.navigation}>
                        {filteredLinks.map((link) => {
                            const sublinkCount = filterUserLinks(link.subLinks, user).length

                            if (sublinkCount > 1) {
                                return (
                                    <StackedNavigationItems
                                        className={styles.navigationItem}
                                        key={generateRandomKey()}
                                        header={link}
                                        items={filterUserLinks(link.subLinks, user)}
                                    />
                                )
                            } else if (sublinkCount === 1) {
                                const sublink = filterUserLinks(link.subLinks, user)[0]
                                return (
                                    <NavigationItem
                                        key={generateRandomKey()}
                                        label={sublink.label}
                                        path={sublink.path}
                                        variant="primary"
                                        icon={link.icon}
                                        iconActive={link.iconActive}
                                        className={styles.navigationItem}
                                    />
                                )
                            } else {
                                return (
                                    <NavigationItem
                                        key={generateRandomKey()}
                                        label={link.label}
                                        path={link.path}
                                        variant="primary"
                                        icon={link.icon}
                                        iconActive={link.iconActive}
                                        className={styles.navigationItem}
                                    />
                                )
                            }
                        })}
                    </div>
                    <BottomBar />
                </>
            )}
        </>
    )
}

export default function Menu() {
    return (
        <AppFrame.Root pageId="Menu">
            <MenuContent />
        </AppFrame.Root>
    )
}
